exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app[data-v-00f323c7] {\n  height: 100%;\n}\n.has-footer[data-v-00f323c7] {\n  padding-bottom: 51px;\n}\n.fade-enter-active[data-v-00f323c7],\n.fade-leave-active[data-v-00f323c7] {\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-00f323c7],\n.fade-leave-to[data-v-00f323c7] {\n  opacity: 0;\n}\n", ""]);

// exports
